import { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';

export default function ForgotPassword() {
  const [email, setEmail]     = useState('');
  const [sent, setSent]       = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'var(--bg)', padding:16 }}>
      <div style={{ width:'100%', maxWidth:400 }}>

        {/* Logo */}
        <div style={{ textAlign:'center', marginBottom:32 }}>
          <div style={{ fontSize:'1.8rem', fontWeight:700, color:'#403EC9', letterSpacing:'-1px' }}>
            alveofit<span style={{ color:'#A5B4FC' }}>°</span>
          </div>
          <div style={{ fontSize:'0.75rem', color:'var(--text-muted)', marginTop:2 }}>Sales Intelligence Platform</div>
        </div>

        <div className="card" style={{ padding:'32px 28px' }}>
          {!sent ? (
            <>
              <h2 style={{ margin:'0 0 6px', fontSize:'1.2rem', fontWeight:700 }}>Forgot your password?</h2>
              <p style={{ margin:'0 0 24px', fontSize:'0.875rem', color:'var(--text-secondary)' }}>
                Enter your work email and we'll send you a reset link valid for 1 hour.
              </p>

              {error && (
                <div style={{ background:'var(--danger-bg)', color:'var(--danger)', borderRadius:'var(--radius-md)', padding:'10px 14px', marginBottom:16, fontSize:'0.875rem' }}>
                  {error}
                </div>
              )}

              <form onSubmit={submit}>
                <div className="form-group">
                  <label className="form-label">Work email</label>
                  <input
                    className="form-control"
                    type="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    placeholder="you@alveo.fit"
                    required
                    autoFocus
                  />
                </div>
                <button
                  type="submit"
                  className="btn btn-primary"
                  style={{ width:'100%', marginTop:8 }}
                  disabled={loading}
                >
                  {loading ? 'Sending…' : 'Send reset link'}
                </button>
              </form>
            </>
          ) : (
            <div style={{ textAlign:'center', padding:'8px 0' }}>
              <div style={{ fontSize:48, marginBottom:16 }}>📧</div>
              <h2 style={{ margin:'0 0 8px', fontSize:'1.2rem', fontWeight:700 }}>Check your inbox</h2>
              <p style={{ margin:'0 0 24px', fontSize:'0.875rem', color:'var(--text-secondary)', lineHeight:1.6 }}>
                If <strong>{email}</strong> is registered, you'll receive a reset link shortly.
                Check your spam folder if it doesn't arrive within a minute.
              </p>
              <button className="btn btn-secondary" style={{ width:'100%' }} onClick={() => setSent(false)}>
                Try a different email
              </button>
            </div>
          )}
        </div>

        <div style={{ textAlign:'center', marginTop:20 }}>
          <Link to="/login" style={{ fontSize:'0.875rem', color:'var(--text-secondary)', textDecoration:'none' }}>
            ← Back to login
          </Link>
        </div>
      </div>
    </div>
  );
}
